import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";

import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

// import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
// import InputLabel from "@mui/material/InputLabel";

import RemoveRedEyeOutlined from "@mui/icons-material/RemoveRedEyeOutlined";
import DeleteOutlineOutlined from "@mui/icons-material/DeleteOutlineOutlined";
import EditOutlined from "@mui/icons-material/EditOutlined";

import { useDispatch, useSelector } from "react-redux";
import {
  openDeleteModal,
  viewDriver,
} from "../../../feature/drivers/driverSlice";
import DriverModals from "./DriverModals";

// import option from "@mui/material/option";
import TextField from "@mui/material/TextField";
// import Box from "@mui/material/Box";
// import InputBase from "@mui/material/InputBase";
// import InputLabel from "@mui/material/InputLabel";
// import NativeSelect from "@mui/material/NativeSelect";
import { Card, Grid, styled } from "@mui/material";
import { useState } from "react";

const selectOption = [
  {
    value: "",
    label: "Select",
  },
  {
    value: "pending",
    label: "Pending",
  },
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
];

export default function DriverTableRow(props) {
  const [select, setSelect] = useState("");
  const { mode } = useSelector((state) => state.mode);
  const dispatch = useDispatch();

  const handleChange = (event) => {
    console.log(event.target.value);
    // setSelect({ ...select, [event.target.name]: event.target.value });
    setSelect(event.target.value);
  };

  return (
    <>
      {props?.row?.map((row) => (
        <TableRow key={row.id}>
          <TableCell component='th' scope='row'>
            {row.id}
          </TableCell>
          <TableCell component='th' scope='row'>
            {row.first_name}
          </TableCell>
          <TableCell component='th' scope='row'>
            {row.last_name}
          </TableCell>
          <TableCell component='th' scope='row'>
            {row.email}
          </TableCell>
          <TableCell component='th' scope='row'>
            {row.mobile_no}
          </TableCell>
          <TableCell component='th' scope='row'>
            {row.mobile_no}
          </TableCell>
          <TableCell component='th' scope='row'>
            {row.mobile_no}
          </TableCell>
          <TableCell component='th' scope='row'>
            {row.mobile_no}
          </TableCell>
          <TableCell component='th' scope='row'>
            {row.mobile_no}
          </TableCell>
          {/* <TableCell component='th' scope='row'>
              <TextField
                sx={{
                  width: "110px",
                }}
                fullWidth
                // label='Select State'
                name='state'
                // onChange={handleChange}
                required
                select
                SelectProps={{ native: true }}
                // value={select}
                variant='outlined'
              >
                {selectOption.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </TextField>
   
          </TableCell> */}
          <TableCell>
            <Tooltip title='Edit'>
              <IconButton
                aria-label='edit'
                sx={{
                  "&:hover": {
                    color: "#3366ff",
                  },
                  color: mode === "light" ? "#222b45" : "#ffffff",
                }}
              >
                <EditOutlined />
              </IconButton>
            </Tooltip>
            <Tooltip title='View'>
              <IconButton
                aria-label='view'
                sx={{
                  "&:hover": {
                    color: "#3366ff",
                  },
                  color: mode === "light" ? "#222b45" : "#ffffff",
                }}
                onClick={() => dispatch(viewDriver(row))}
              >
                <RemoveRedEyeOutlined />
              </IconButton>
            </Tooltip>
            <Tooltip title='Delete'>
              <IconButton
                aria-label='delete'
                sx={{
                  "&:hover": {
                    color: "#F24C4C",
                  },
                  color: mode === "light" ? "#222b45" : "#ffffff",
                }}
                onClick={() => dispatch(openDeleteModal(row))}
              >
                <DeleteOutlineOutlined />
              </IconButton>
            </Tooltip>
          </TableCell>
        </TableRow>
      ))}

      <DriverModals />
    </>
  );
}
